

export const routes = [ 

  // () => import(/* webpackChunkName: "group-dashboard" */ '../components/')
  
  { path: '/', name: 'home', component: () => import(/* webpackChunkName: "group-welcome" */ '../views/Home.vue'), },
  
  { path: '/PageIntro', name: 'PageIntro', component: () => import(/* webpackChunkName: "group-welcome" */ '../views/PageIntro.vue'), },
  
  { path: '/PageSMSContent', name: 'PageSMSContent', component: () => import(/* webpackChunkName: "group-welcome" */ '../views/PageSMSContent.vue'), },
  
  { path: '/PageWhySMS', name: 'PageWhySMS', component: () => import(/* webpackChunkName: "group-welcome" */ '../views/PageWhySMS.vue'), },
  
  { path: '/PageDailyStartup', name: 'PageDailyStartup', component: () => import(/* webpackChunkName: "group-welcome" */ '../views/PageDailyStartup.vue'), },
  
  { path: '/PageFive', name: 'PageFive', component: () => import(/* webpackChunkName: "group-welcome" */ '../views/PageFive.vue'), },
  
  { path: '/Tutorial', name: 'Tutorial', component: () => import(/* webpackChunkName: "group-welcome" */ '../views/Tutorial.vue'), },
  
  { path: '/HowItWorks', name: 'HowItWorks', component: () => import(/* webpackChunkName: "group-welcome" */ '../views/HowItWorks.vue'), },

  // { path: '/my-revisions', name: 'my-revisions', component: () => import(/* webpackChunkName: "profile" */ '../profile/MyRevisions'), meta: { transition: 'overlay-right-full' }, props: true },


  // { path: '/404', name: '404', component: () => import('../components/Error404')  },

  { path: '*', redirect: '/'  },

  { path: '/', name: 'Home', component: () => import(/* webpackChunkName: "group-welcome" */ '../views/Home.vue') },

  { path: '/parent', component: () => import(/* webpackChunkName: "group-welcome" */ '../views/Home.vue'),
    children: [
      { path: '', component: () => import(/* webpackChunkName: "group-welcome" */ '../views/Home.vue') },
      { path: 'PageIntro', component: () => import(/* webpackChunkName: "group-welcome" */ '../views/PageIntro.vue') },
      { path: 'PageSMSContent', component: () => import(/* webpackChunkName: "group-welcome" */ '../views/PageSMSContent.vue') }
    ]
  }

  // { path: '/parent', component: Parent,
  //   children: [
  //     { path: '', component: Default },
  //     { path: 'foo', component: Foo },
  //     { path: 'bar', component: Bar }
  //   ]
  // }



]